import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';
import './styles/global.css';

// Error fallback component
const ErrorFallback: React.FC<{ error: Error }> = ({ error }) => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
    <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6 space-y-6">
      <h1 className="text-3xl font-bold text-center text-red-600">Oops! Something went wrong.</h1>
      <p className="text-center text-gray-700">We're sorry, but an error occurred. Please try again later.</p>
      <p className="text-center text-gray-500">Error details: {error.message}</p>
      <button
        onClick={() => window.location.reload()}
        className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
      >
        Reload Page
      </button>
    </div>
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
